<div class="row">
    <div class="col-lg-12 input-control">
        <div class="jobcard-label" [ngClass]="{'red': jobcard?.selectedServiceTypes?.length === 0}">{{
            'bikeshop.menu.service_types' | translate }}</div>
        <p-multiSelect #serviceTypeDropDown [options]="serviceTypeGroups" [optionLabel]="'serviceType'"
            optionValue="serviceTypeID" [filter]="true" filterBy="search,reverseSearch" scrollHeight="300px"
            [resetFilterOnHide]="true" autofocus="true" [ngModel]="selectedServiceTypes"
            (onChange)="serviceTypeSelected($event)" [showToggleAll]="false"
            [disabled]="jobcard?.quote?.statusID === 10"
            defaultLabel="{{ 'general.choose' | translate}}">
        </p-multiSelect>
    </div>

</div>

<div class="row">
    <div class="col-lg-8 input-control">
        <div class="jobcard-label">{{ 'bikeshop.calendar.availability.technician' | translate }}</div>
        <hub-dropdown #technicianDropdown [icon]="'user'" [options]="technicians" [(ngModel)]="jobcard.technician" 
            (selectionChange)="onTechnicianChanged($event)"></hub-dropdown>
    </div>
</div>

<div class="row">
    <div class="col-lg-8 input-control">
        <div class="jobcard-label">{{'bikeshop.workshop.jobcard.scheduled_on' | translate}}</div>
        <hub-datepicker [(ngModel)]="scheduleDate" [minDate]="minDate" [dateFormat]="'D, dd M yy'" [required]="true" [disabled]="loadingDates"
            (onDateChanged)="onDateChanged($event)"></hub-datepicker>
    </div>
    <div class="col-lg-4 input-control">
        <hub-datepicker [icon]="'clock'" [(ngModel)]="scheduleDate" [timeOnly]="true" [minDate]="minDate" [disabled]="loadingDates"
            [required]="true" [dateFormat]="'h:mm tt'" (onDateChanged)="onDateChanged($event, true)"></hub-datepicker>
    </div>
</div>
<div class="row input-control-extra" *ngIf="!addRequiredByDate">
    <div class="col-lg-12">
        <hub-button text="{{ 'bikeshop.workshop.jobcard.add_required_by_date' | translate }}"
            [disabled]="addRequiredByDate" [size]="'sm'" [style]="'borderless'" [icon]="'plus'"
            (buttonClick)="addRequiredByDate = true;">
        </hub-button>
    </div>
</div>
<div class="row" *ngIf="addRequiredByDate">
    <div class="col-lg-8 input-control">
        <div class="jobcard-label">{{'bikeshop.modal.shedule_service.required_by' | translate}}</div>
        <hub-datepicker [(ngModel)]="requiredByDate" [minDate]="minRequiredByDate" [required]="true"
            [dateFormat]="'D, dd M yy'" (onDateChanged)="onRequiredDateChanged($event, true)"></hub-datepicker>
    </div>
    <div class="col-lg-4 input-control">
        <hub-datepicker [icon]="'clock'" [(ngModel)]="requiredByDate" [timeOnly]="true"
            [minDate]="minRequiredByDate" [required]="true" [dateFormat]="'h:mm tt'"
            (onDateChanged)="onRequiredDateChanged($event)"></hub-datepicker>
    </div>
</div>
<div class="row input-control-extra" *ngIf="addRequiredByDate">
    <div class="col-lg-12">
        <hub-button text="{{ 'bikeshop.workshop.jobcard.remove_required_by_date' | translate }}" [size]="'sm'"
            [style]="'borderless-secondary'" (buttonClick)="clearRequiredByDate()">
        </hub-button>
    </div>
</div>

<div class="row">
    <div class="col-lg-8 input-control">
        <div class="jobcard-label">{{ 'bikeshop.modal.shedule_service.booked_in_by' | translate }}</div>
        <hub-dropdown #createdByDropdown [icon]="'user'" [options]="systemUsers" [disabled]="!partnerData.CreatedByOverrideOnBooking" [(ngModel)]="jobcard.createdBy" (ngModelChange)="onCreatedByChanged($event)"></hub-dropdown>
    </div>
</div>

<div class="row" *ngIf="jobcard.id > 0">
    <div class="col-lg-8 input-control">
        <div class="jobcard-label">{{ 'bikeshop.modal.shedule_service.checked_by' | translate }}</div>
        <hub-dropdown #checkedByDropdown [icon]="'user'" [options]="systemUsers" [(ngModel)]="jobcard.checkedBy" (ngModelChange)="onCheckedByChanged($event)"></hub-dropdown>
    </div>
</div>

<div class="row" *ngIf="jobcard.id">
    <div class="col-lg-8 input-control">
            <hub-input *ngIf="bays.length == 0" #bayTagNoInput [label]="'bikeshop.workshop.jobcard.items.bay_tag_no' | translate" (ngModelChange)="onBayTagNoChanged($event)"
                [(ngModel)]="jobcard.bayNo"></hub-input>

            <hub-dropdown #bayDropdown *ngIf="bays.length > 0" [formatList]="bays" [label]="'bikeshop.workshop.jobcard.items.bay_tag_no' | translate" (ngModelChange)="onBayTagNoChanged($event)"
                [(ngModel)]="bay" [options]="bays" [optionLabel]="'label'" [optionValue]="'value'"></hub-dropdown>

    </div>
</div>



<div *ngIf="showThirdParties == true">
    <div class="row">
        <div class="col-lg-8">
            <hub-dropdown #thirdPartyDropdown label="{{'bikeshop.modal.shedule_service.thirdparty' | translate }}" [options]="thirdParties" (ngModelChange)="onThirdPartyChanged($event)"
                [(ngModel)]="jobcard.thirdPartyID"></hub-dropdown>
        </div>
    </div>

    <div class="row margin-top-8">
        <div class="col-md-8 input-control">
            <hub-checkbox label="{{ 'bikeshop.modal.shedule_service.thirdparty_responsibleforpayment' | translate}}" [(ngModel)]="jobcard.thirdPartyIsResponsibleForPayment" (ngModelChange)="onThirdPartyResponsibleForPaymentChanged($event)"
                [disabled]="!jobcard.thirdPartyID"></hub-checkbox>
        </div>
    </div>
</div>

<p-toast key="jobcard-details-updated" position="bottom-center" [style]="{ 'z-index': '10000' }" [baseZIndex]="10000" [showTransitionOptions]="'0ms'"
    [hideTransitionOptions]="'0ms'"></p-toast>
<p-confirmDialog key="availability-error"></p-confirmDialog>    
